<template>
    <div class>
        <el-tabs v-model="tabName">
            <el-tab-pane label="充电订单" name="first">
                <STable v-if="tabName === 'first'" ref="tableref" :url="url" :columns="columns" :handles="handles"
                    :query="query" :toolbar="toolbar" :selection="false" label-width="120px" />
            </el-tab-pane>
            <!-- <el-tab-pane label="占用订单" name="second">
        <STable
         v-if="tabName==='second'"
          ref="tableref1"
          :url="url1"
          :columns="columns1"
          :handles="handles1"
          :query="query1"
          :selection="false"
          label-width="120px"
        />
      </el-tab-pane> -->
        </el-tabs>
    </div>
</template>

<script>
import { HOST, EV_HOST } from "@/utils/host";
import fieldFilter from "@/utils/fieldFilter.js"
let dateStart = new Date();
dateStart.setDate(1);
dateStart.setHours(0)
dateStart.setMinutes(0)
dateStart.setSeconds(0)
export default {
    name: "Shishidingdan",
    components: {},
    data() {
        return {
            tabName: "first",
            url: "/finance/order/getHistoryOrderPage?view=STATION&orderStatus=1",
            url1: "/admin/occupyorder/listOrder",
            columns: [
                {
                    label: "充电单号",
                    prop: "startChargeSeq",
                },
                {
                    label: "用户账号",
                    prop: "loginName",
                },
                {
                    label: "归属企业",
                    prop: "belongOrg",
                },
                {
                    label: "充电车辆",
                    prop: "plateNumber",
                },
                {
                    label: "车辆VIN码",
                    prop: "vINCode",
                    width: "180px",
                    template: (index, reocrd) => {
                        return reocrd.vINCode
                    }
                },
                // {
                //   label: '订单金额',
                //   prop: 'totalMoney',
                //   template: (index, reocrd) => {
                //     return this.getFloat(reocrd.totalMoney)
                //   }
                // },
                {
                    label: "应收金额",
                    prop: "totalMoney",
                },
                {
                    label: "应收电费",
                    prop: "elecMoney",
                },
                {
                    label: "应收服务费",
                    prop: "serviceMoney",
                },
                {
                    label: "实收金额",
                    prop: "totalMoneyActual",
                    template: (index, reocrd) => {
                        return this.getFixed2(reocrd.totalMoneyActual);
                    },
                },
                {
                    label: "实收电费",
                    prop: "elecMoneyActual",
                },
                {
                    label: "实收服务费",
                    prop: "serviceMoneyActual",
                },
                {
                    label: "优惠抵扣金额",
                    prop: "discountMoney",
                },
                {
                    label: "开始充电时间",
                    prop: "startTime",
                    width: "150px",
                },
                {
                    label: "结束充电时间",
                    prop: "endTime",
                    width: "150px",
                    template: (index, reocrd) => {
                        return reocrd.endTime ? reocrd.endTime : "--";
                    },
                },
                {
                    label: "订单支付时间",
                    prop: "orderInfo",
                    width: "150px",
                    template: (index, reocrd) => {
                        console.log(reocrd)
                        return reocrd.orderInfo.payTime
                    },
                },
                {
                    label: "充电时长",
                    prop: "chargeTime",
                    width: "130px",
                    template: (index, reocrd) => {
                        return this.getFormattedTimeDiff(new Date(reocrd.startTime), new Date(reocrd.endTime))
                    },
                },
                {
                    label: "已充电量（度）",
                    prop: "totalPower",
                    template: (index, reocrd) => {
                        return this.getFloat(reocrd.totalPower);
                    },
                },
                {
                    label: "起始SOC",
                    prop: "orderInfo",
                    template: (index, reocrd) => {
                        return reocrd.orderInfo.startSOC ? parseFloat(reocrd.orderInfo.startSOC) + "%" : "--";
                    },
                },
                {
                    label: "结束SOC",
                    prop: "orderInfo",
                    template: (index, reocrd) => {
                        return reocrd.orderInfo.endSOC ? parseFloat(reocrd.orderInfo.endSOC) + "%" : "--";
                    },
                },
                {
                    label: "电站名称",
                    prop: "station",
                    template: (index, reocrd) => {
                        return reocrd.station.stationName
                    },
                },
                {
                    label: "终端名称",
                    prop: "connectorName",
                    template: (index, reocrd) => {
                        return reocrd.connector.connectorName
                    },
                },
                // {
                //   label: "电桩功率",
                //   prop: "connectorPower"
                // },
                {
                    label: "运营商",
                    prop: "orgName",
                    template: (index, reocrd) => {
                        return reocrd.org.name
                    },
                },
                {
                    label: "订单类型",
                    template: (index, reocrd) => {
                        const orderTyepMap = {
                            0: "平台",
                            1: "流量方",
                            2: "车辆机构",
                        }
                        return orderTyepMap[reocrd.orderInfo.orderType] || "未知"
                    },

                },
                {
                    label: '互联互通订单号',
                    prop: 'hlhtStartChargeSeq'
                }
                // {
                //   label: "充电模式",
                //   prop: "chargeMode"
                // }
            ],
            columns1: [
                {
                    label: "占用订单号",
                    prop: "occupyNo",
                },
                {
                    label: "用户账号",
                    prop: "loginName",
                },
                {
                    label: "归属企业",
                    prop: "orgName",
                },
                {
                    label: "电站名称",
                    prop: "stationName",
                },
                {
                    label: "占用终端名称",
                    prop: "deviceName",
                },
                {
                    label: "占用终端编码",
                    prop: "connectorId",
                },
                {
                    label: "占用时长",
                    prop: "time",
                    template: (index, reocrd) => {
                        var hours = parseInt(
                            (reocrd.time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                        );
                        var minutes = Math.ceil(
                            (reocrd.time % (1000 * 60 * 60)) / (1000 * 60)
                        );
                        if (hours == 0) {
                            return minutes + " 分钟 ";
                        } else {
                            return hours + "小时" + minutes + " 分钟 ";
                        }
                    },
                },
                {
                    label: "占用收费",
                    prop: "totalAmount",
                    template: (index, reocrd) => {
                        return reocrd.totalAmount + "元";
                    },
                },
                {
                    label: "订单类型",
                    prop: "orderType",
                    template: (index, reocrd) => {
                        return reocrd.orderType == 0
                            ? "平台"
                            : reocrd.orderType == 1
                                ? "流量方"
                                : "--";
                    },
                },
                {
                    label: "结束占位原因",
                    prop: "stopType",
                    template: (index, reocrd) => {
                        return reocrd.stopType == 1
                            ? "正常结束"
                            : reocrd.stopType == 2
                                ? "手动结束"
                                : "--";
                    },
                },
                {
                    label: "订单支付时间",
                    prop: "payTime",
                    width: "150px",
                },
            ],
            // 操作栏
            handles: {
                width: 300,
                btns: [
                    {
                        label: "详情",
                        icon: "el-icon-view",
                        permission: "order.stationhistory.details",
                        handle: (resp) => {
                            this.$router.push({
                                path: "./historyDetail",
                                query: { data: resp.id, num: resp.startChargeSeq },
                            });
                        },
                    },
                    {
                        label: "补推订单",
                        icon: "el-icon-view",
                        permission: "order.stationhistory.details",
                        isShowFun: (record) => {
                            return record.orderInfo.orderType == 1;
                        },
                        handle: (resp) => {
                            const data = {
                                id: resp.id,
                            };
                            this.$store.dispatch("form/handle", {
                                url: "/finance/order/getHistoryOrderDetail",
                                data: data,
                                method: "get",
                                callback: (resp) => {
                                    const h = this.$createElement;
                                    this.$confirm(
                                        h("div", null, [
                                            h("p", null, "确认需要向流量方补推订单结算数据？"),
                                            h("p", null, `流量方：${resp.belongOrg}`),
                                            h("p", null, `流量方单号：${resp.hlhtStartChargeSeq}`),
                                        ]),
                                        "",
                                        {
                                            confirmButtonText: "确定",
                                            cancelButtonText: "取消",
                                            closeOnClickModal: false,
                                            type: "warning",
                                        }
                                    ).then(() => {
                                        let data2 = {
                                            startChargeSeq: resp.hlhtStartChargeSeq,
                                        };
                                        this.$store.dispatch("form/handle", {
                                            url: "/evserv/newApi/pushOrder",
                                            data: data2,
                                            method: "post",
                                            callback: (resp2) => {
                                                console.log(resp2)
                                            },
                                        });
                                        // this.handleToolbarExecute(option, data);
                                        // this.$refs.queryTable.clearSelection();
                                    });
                                },
                            });
                        },
                    },
                    {
                        label: "道闸补推",
                        icon: "el-icon-view",
                        permission: "order.stationhistory.details",
                        isShowFun: (record) => {
                            return record.orderInfo.orderType == 1;
                        },
                        handle: (resp) => {
                            const data = {
                                id: resp.id,
                            };
                            if (!resp.plateNumber) {
                                this.$notify({
                                    title: "失败",
                                    message: "该订单未绑定车牌",
                                    type: "error",
                                });
                                return
                            }
                            const h = this.$createElement;
                            this.$confirm(
                                h("div", null, [
                                    h("p", null, "将会执行道闸减免推送补推！"),
                                    h("p", null, `车牌号：${resp.plateNumber}`),
                                ]),
                                "",
                                {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    closeOnClickModal: false,
                                    type: "warning",
                                }
                            ).then(() => {
                                let data2 = {
                                    startChargeSeq: resp.hlhtStartChargeSeq,
                                };
                                this.$store.dispatch("form/handle", {
                                    url: "/evserv/newApi/pushBlock",
                                    data: data2,
                                    method: "post",
                                    callback: (resp2) => {
                                        this.$refs.tableref.queryTable();
                                    },
                                });
                            });
                        },
                    },
                    {
                        label: "重新分润",
                        icon: "el-icon-refresh",
                        permission: "order.stationhistory.details",
                        isConfirm: true,
                        confirmText: "确定要对该订单重新分润吗？",
                        url: "/finance/profit/redistribute",
                        method: "get",
                        before: (index, record) => {
                            return { orderId: record.id };
                        },
                        handle: (resp) => {
                            this.$notify({
                                title: "成功",
                                message: "重新分润成功",
                                type: "success",
                            });
                            this.$refs.tableref.queryTable();
                        },
                    },
                ],
            },
            // 操作栏
            handles1: {
                width: 200,
                btns: [
                    {
                        label: "详情",
                        permission: "order.stationrealtime.details",
                        handle: (resp) => {
                            this.$router.push({
                                path: "./occupyDetail",
                                query: { id: resp.id, pageState: 3 },
                            });
                        },
                    },
                ],
            },
            query: [
                {
                    label: "开始充电",
                    prop: "startTime",
                    placeholder: "",
                    type: "date2",
                    haveDefaultDate: true,
                    option: {
                        type: "date2",
                        defaultDate: [this.dateFormat(dateStart), this.dateFormat(new Date)],
                    },
                },
                {
                    label: "充电单号",
                    prop: "startChargeSeq",
                    placeholder: "请输入充电单号",
                },
                // {
                //     label: "充电方式",
                //     prop: "chargeType",
                //     placeholder: "请输入充电方式",
                //     type: "select",
                //     data: [
                //         {
                //             label: "平台APP",
                //             value: "APP",
                //         },
                //         {
                //             label: "平台小程序",
                //             value: "WSP",
                //         },
                //         {
                //             label: "平台刷卡",
                //             value: "CARD",
                //         },
                //         {
                //             label: "第三方",
                //             value: "OTHER",
                //         },
                //         {
                //             label: "VIN码充电",
                //             value: "VIN",
                //         },
                //     ],
                // },
                // {
                //     label: "归属企业",
                //     prop: "belongOrg",
                //     placeholder: "请输入归属企业",
                // },
                {
                    label: "电站名称",
                    prop: "stationName",
                    placeholder: "请输入电站名称",
                },
                // {
                //     label: "终端名称",
                //     prop: "connectorName",
                //     placeholder: "请输入终端名称",
                // },
                // {
                //     label: "运营商",
                //     prop: "orgName",
                //     placeholder: "请输入运营商",
                // },
                // {
                //     label: "订单结算",
                //     prop: "payTime",
                //     placeholder: "",
                //     type: "date2",
                //     haveDefaultDate: true,
                //     option: {
                //         type: "date2",
                //         // defaultDate: [this.dateFormat(dateStart), this.dateFormat(new Date)],
                //     },
                // },
                {
                    label: "充电车辆",
                    prop: "plateNumber",
                    placeholder: "请输入充电车辆",
                },
                {
                    label: '互联互通订单号',
                    prop: 'hlhtStartChargeSeq',
                    placeholder: '请输入互联互通订单号',
                }
                // {
                //   label: '电桩功率',
                //   prop: 'connectorPower',
                //   placeholder: '请输入电桩功率'
                // },
                // {
                //   label: "充电模式",
                //   prop: "chargeMode",
                //   placeholder: "请选择充电模式",
                //   type: "select",
                //   data: [
                //     {
                //       label: "单充",
                //       value: 0
                //     },
                //     {
                //       label: "双枪并充",
                //       value: 1
                //     },
                //   ]
                // },
                // {
                //   label: '结算类型',
                //   prop: 'payType',
                //   placeholder: '请选择结算模式',
                //   type: 'select',
                //   data: [
                //     {
                //       label: '正常单自动结算',
                //       value: 0
                //     },
                //     {
                //       label: '手动结算',
                //       value: 1
                //     },
                //     {
                //       label: '异常单自动结算',
                //       value: 2
                //     },
                //     {
                //       label: '平台延迟结算',
                //       value: 3
                //     },
                //     {
                //       label: '第三方延迟结算',
                //       value: 4
                //     },
                //     {
                //       label: '离线结算',
                //       value: 5
                //     }
                //   ]
                // }
                // {
                //   label: '支付状态',
                //   prop: 'orderStatus',
                //   placeholder: '请选择支付状态',
                //   type: 'select',
                //   data: [
                //     {
                //       label: '待支付',
                //       value: 0
                //     },
                //     {
                //       label: '已支付',
                //       value: 1
                //     }
                //   ]
                // }
            ],
            query1: [
                {
                    label: "订单开始时间",
                    prop: "startTime",
                    placeholder: "",
                    type: "date2",
                    option: {
                        type: "date2",
                        defaultDate: [this.dateFormat(dateStart), this.dateFormat(new Date)],
                    },
                },
                {
                    label: "占用订单号",
                    prop: "orderNo",
                    placeholder: "请输入占用订单号",
                },
                {
                    label: "用户账号",
                    prop: "loginName",
                    placeholder: "请输入用户账号",
                },
                {
                    label: "归属企业",
                    prop: "orgName",
                    placeholder: "请输入归属企业",
                },
                {
                    label: "订单类型",
                    prop: "orderType",
                    placeholder: "请选择订单类型",
                    type: "select",
                    data: [
                        {
                            label: "平台",
                            value: 0,
                        },
                        {
                            label: "流量方",
                            value: 1,
                        },
                    ],
                },
                {
                    label: "电站名称",
                    prop: "stationName",
                    placeholder: "请输入电站名称",
                },
                // {
                //     label: "占用终端编码",
                //     prop: "connectorId",
                //     placeholder: "请输入占用终端编码",
                // },
                // {
                //     label: "结束占位原因",
                //     prop: "stopType",
                //     placeholder: "请选择结束占位原因",
                //     type: "select",
                //     data: [
                //         {
                //             label: "正常结束",
                //             value: 1,
                //         },
                //         {
                //             label: "手动结束",
                //             value: 2,
                //         },
                //     ],
                // },
            ],
            toolbar: [
                {
                    label: "导出",
                    icon: "el-icon-download",
                    permission: "order.stationhistory.export",
                    type: "primary",
                    handle: (resp) => {
                        const url = HOST + "/finance/order/export?view=STATION";
                        const queryData = this.$refs.tableref.getQueryData();
                        queryData.token = window.localStorage.getItem("token");
                        queryData.companyId = window.localStorage.getItem("curCompanyId");
                        $.fileDownload(url, {
                            httpMethod: "get",
                            data: queryData,
                            failCallback: (html, url) => {
                                this.$notify({
                                    title: "失败",
                                    message: "导出失败",
                                    type: "error",
                                });
                            },
                        });
                    },
                },
            ],
            toolbar1: [
                {
                    label: "导出",
                    icon: "el-icon-download",
                    permission: "order.stationhistory.export",
                    type: "primary",
                    handle: (resp) => {
                        const url = HOST + "/admin/occupyorder/export";
                        const queryData = this.$refs.tableref1.getQueryData();
                        queryData.token = window.localStorage.getItem("token");
                        queryData.companyId = window.localStorage.getItem("curCompanyId");
                        $.fileDownload(url, {
                            httpMethod: "get",
                            data: queryData,
                            failCallback: (html, url) => {
                                this.$notify({
                                    title: "失败",
                                    message: "导出失败",
                                    type: "error",
                                });
                            },
                        });
                    },
                },
            ],
        };
    },
    mounted() {
        // const tabs = localStorage.getItem('tabName')
        // if(tabs === "second"){
        //   this.tabName = "second"
        // }
        // localStorage.removeItem('tabName');
    },
    beforeMount() {
        const tabs = localStorage.getItem("tabName");
        if (tabs === "second") {
            this.tabName = "second";
        }
        localStorage.removeItem("tabName");
    },

    methods: {
        dateFormat(time) {
            var date = new Date(time);
            var year = date.getFullYear();
            var month =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours =
                date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes =
                date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds =
                date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            return (
                year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hours +
                ":" +
                minutes +
                ":" +
                seconds
            );
        },
        /**
         * 返回格式化的时间差（如 "2天 3小时 15分钟"）
         * @param start 开始时间
         * @param end 结束时间
         * @returns 格式化字符串
         */
        getFormattedTimeDiff(start, end) {
            if (!start || !end) {
                return "";
            }
            const diffInMs = Math.abs(end.getTime() - start.getTime());

            const seconds = Math.floor(diffInMs / 1000) % 60;
            const minutes = Math.floor(diffInMs / (1000 * 60)) % 60;
            const hours = Math.floor(diffInMs / (1000 * 60 * 60)) % 24;
            const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

            const parts = [];
            if (days > 0) parts.push(`${days}天`);
            if (hours > 0) parts.push(`${hours}小时`);
            if (minutes > 0) parts.push(`${minutes}分钟`);
            if (seconds > 0) parts.push(`${seconds}秒`);

            return parts.join(' ') || '0秒';
        }
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/orderManagement/historyStationmanagement.vue